export const createOneTimeRunnable = (func: () => void) => {
    let hasRun = false
    return () => {
        if (hasRun) return
        hasRun = true
        func()
    }
}
